/**
 * Technically this function's calcluated values should be represented
 * using the US National Institute of Standards and Technology (NIST) recommended
 * kiB, MiB, etc... because we are using base-2 (2^10 -> 1024); however, these
 * abbretiations aren't commonplace yet.
 *
 * There is much confusion over KiB vs KB vs kB, etc... and this is partly due to
 * the difference in how a computer works (base-2 binary) and how we measure real-world
 * things like mass using a Metric system (base-10 SI), but there are a few other factors too.
 * Some other factors include manufacturers and marketing materials often using prefixes
 * interchangeably, as well as a lack of a standard for many years and general lag in
 * information systems education. For example, much of the general public refer to their
 * internet speed with the term Megabytes per second, when in fact it is
 * Megabits per second (Mbps not MB/s).
 *
 * Chart 1) How prefixes for binary multiples relate to SI prefixes
 * |--------------------------------------------------------|
 * | Decmical Prefix (SI) | Factor | Name / Symbol | Factor |
 * |--------------------------------------------------------|
 * | kilo (k)             | 10^3   | kibi (Ki)     | 2^10   |
 * | mega (M)             | 10^6   | mebi (Mi)     | 2^20   |
 * | giga (G)             | 10^9   | gibi (Gi)     | 2^30   |
 * | tera (T)             | 10^12  | tebi (Ti)     | 2^40   |
 * |--------------------------------------------------------|
 */
export const formatFileSize = (size: number): string => {
  const units = ['B', 'kB', 'MB', 'GB', 'TB'];

  if (size <= 0) {
    return `0 ${units[0]}`;
  }

  const i = Math.floor(Math.log(size) / Math.log(1024));

  return `${(size / 1024 ** i).toFixed(0)} ${units[i]}`;
};
